import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { integrationMaxWidth } from "app/pages/sales-intelligence/pages/manage-export/style";

export const StyledManagementContainer = styled.div`
    flex-grow: 1;
    background-color: ${colorsPalettes.bluegrey[100]};
`;

export const StyledManagementWrapper = styled.div<{ isSupressionList?: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: ${({ isSupressionList = false }) => (isSupressionList ? "center" : "stretch")};
    width: 100%;
    padding-bottom: 16px;
    margin: 0 auto;

    ${integrationMaxWidth}
`;

export const StyledListImage = styled.img`
    width: 100px;
    height: 100px;
`;
